<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span><b>Mental Case</b></span></p>
<p class="authorname-1"><span><b>A Ben Tolliver Mystery</b></span></p>
<p class="authorname"><span>James Neal Harvey</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/logo1.jpg"/></span></p>
<p class="publisher1"><span>MYSTERIOUSPRESS.COM</span></p>
<p class="publisher2"><span><img alt="image" class="svg" src="images/logo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0245b56f